import { t } from "@/i18n/LanguageContext";
import axios from "axios";
import { resolveApiBaseUrl } from "@/lib/apiOrigin";

export const API = resolveApiBaseUrl(process.env.REACT_APP_BACKEND_URL, window.location.origin);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gfc_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err, fallback = "Si è verificato un errore. Riprova.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return t(detail);
  if (Array.isArray(detail)) return detail.map((e) => {
    if (e.type === "missing") return t("Campo obbligatorio.");
    if (e.type === "string_too_short") return t("Il testo inserito è troppo breve.");
    if (e.type === "value_error" && e.loc?.includes("email")) return t("Inserisci un indirizzo email valido.");
    return t("Il valore inserito non è valido.");
  }).filter(Boolean).join(" ");
  return t(fallback);
}
